export const FETCH_QUESTIONS_SUCCESS = 'FETCH_QUESTIONS_SUCCESS';
export const STORE_RESULT_SUCCESS = 'STORE_RESULT_SUCCESS';
export const FETCH_QUIZ_DATA_SUCCESS = 'FETCH_QUIZ_DATA_SUCCESS';
export const FETCH_UNASSIGNED_SKILLS_SUCCESS = 'FETCH_UNASSIGNED_SKILLS_SUCCESS';
export const STORE_NUDGE_RESULT_SUCCESS = 'STORE_NUDGE_RESULT_SUCCESS';
